export default __webpack_public_path__ + "static/media/me.7c97fe06.jpg";